import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { DeleteUser } from '../redux/features/AdminService';

const useUserDeletion = (refreshFunction) => {
  const dispatch = useDispatch();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleDeleteClick = (user) => {
    setUserToDelete(user);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (!userToDelete) return;

    setDeleteLoading(true);
    try {
      await dispatch(DeleteUser({ userId: userToDelete._id })).unwrap();

      // Add a small delay to ensure the deletion is processed
      setTimeout(() => {
        if (refreshFunction) {
          refreshFunction();
        }
      }, 500);

      setShowDeleteModal(false);
      setUserToDelete(null);
    } catch (error) {
      console.error("Error deleting user:", error);
      alert("Failed to delete user. Please try again.");
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setUserToDelete(null);
  };

  return {
    showDeleteModal,
    userToDelete,
    deleteLoading,
    handleDeleteClick,
    handleDeleteConfirm,
    handleDeleteCancel,
  };
};

export default useUserDeletion;
